import { endOfDay } from 'date-fns';
import {
  DocumentOrganizationKeys,
  FilterDocumentDateCustomTypes,
  FilterDocumentDateFilterTypes,
  FilterOptionKeys,
} from 'shared/types/filter-document';
import {
  GroupByMode,
  SortingMode,
  TaskGroupBy,
} from 'shared/types/sorting-mode';
import { Timestamp } from 'shared/types/timestamp';

export const defaultFilter = (today: Timestamp) => {
  const baseFilters = {
    // Hide habits if setting is enabled (old data)
    [FilterOptionKeys.Type]: null,
    // Filter by tags if any selected (old data)
    [FilterOptionKeys.Tag]: null,
  };

  const scheduledBranch = {
    [FilterOptionKeys.Date]: {
      type: FilterDocumentDateFilterTypes.Custom,
      custom: {
        type: FilterDocumentDateCustomTypes.Before,
        start: null,
        end: endOfDay(today) as Timestamp,
      },
    },
  };

  const deadlineBranch = {
    [FilterOptionKeys.Deadline]: {
      type: FilterDocumentDateFilterTypes.Custom,
      custom: {
        type: FilterDocumentDateCustomTypes.Before,
        start: null,
        end: endOfDay(today) as Timestamp,
      },
    },
  };

  return {
    [DocumentOrganizationKeys.GroupByMode]: GroupByMode.Deadline as TaskGroupBy,
    [DocumentOrganizationKeys.SortingMode]: SortingMode.DueDate,
    [DocumentOrganizationKeys.Filters]: baseFilters,
    [DocumentOrganizationKeys.Or]: [scheduledBranch, deadlineBranch],
  };
};
